document.addEventListener('DOMContentLoaded', () => {
  // モーダルの表示時間（ミリ秒で指定）
  const MODAL_ACTIVE_MIL_SEC = 2000;

  const getDescriptionContent = () => {
    return `
      <span class="cartin-modal__description-icon"></span>
      <span class="cartin-modal__description-label">
        カートにアイテムが追加されました。
      </span>
    `;
  }

  const getModalJson = ({ productTitle, imageUrl, color, size }) => {
    const details = [];
    if (color) {
      details.push({
        title: "カラー",
        value: color
      });
    }
    if (size) {
      details.push({
        title: "サイズ",
        value: size
      });
    }

    const productJson = {
      type: "product",
      class: "cartin-modal__product",
      title: productTitle,
      image: imageUrl,
    }

    if (details.length) {
      productJson.details = details;
    }

    const modalJson = {
      size: 'medium',
      class: 'cartin-modal',
      fields: [
        {
          type: "html",
          class: "cartin-modal__description",
          content: getDescriptionContent()
        },
        productJson
      ]
    }

    return modalJson;
  }

  const updateCartBubble = () => {
    const elCartBubbleValue = document.querySelector('.js-cart-bubble-value');
    if (!elCartBubbleValue) return;

    fetch('/cart.js')
      .then((response) => response.json())
      .then((data) => {
        const itemCount = data.item_count;
        elCartBubbleValue.textContent = String(itemCount);
      });
  }

  document.addEventListener('product-cartin', (e) => {
    const detail = e.detail;

    const modalJson = getModalJson({
      productTitle: detail.productTitle,
      imageUrl: detail.imageUrl,
      color: detail.color,
      size: detail.size
    });

    const callback = () => {};
    const closeCallback = null;
    const options = {
      closeTimer: MODAL_ACTIVE_MIL_SEC
    }
    openTriggerModal(modalJson, callback, closeCallback, options);

    updateCartBubble();
  });

})